import React from "react";
import { Input, Textarea, Upload } from "../../../../components/Form";
import Tabs from "../../../../components/Tabs";
import { getMessage } from "../../../../lib/translator";
import Testimonial from "../../../../components/Layout/Testimonial";

const TestimonialLayout = ({ getState, updateState, parent }) => {
  // ----------------------------------------------------------
  // -------------------------sliders--------------------------
  const activeIndex = Number(getState(["activeIndex"])) || 0;
  const emptySlide = {
    testimonial: "",
    authorName: "",
  };
  const slides = getState(["slides"]) || [emptySlide];
  const currentSlide = slides[activeIndex] || emptySlide;

  if (!getState(["slides"])) {
    updateState(["slides"], slides); // TODO: Move this to componentWillMount of layout
  }

  // Since updateStateRecursively had some issues with this structure
  const newState = (key, value) => {
    parent.setState((prevState) => {
      const newState = Object.assign({}, prevState);
      newState.values.slides[activeIndex][key] = value;
      return prevState;
    });
  };
  const showDelete = slides && slides.length > 1;

  return (
    <>
      <div className="form-sections">
        <div className="form-section">
          <Input
            label="title"
            placeholder="Please enter title here"
            value={getState(["title"]) || ""}
            onChange={(value) => {
              updateState(["title"], value);
            }}
          />
        </div>
        <div className="form-section">
          <Input
            label="subtitle"
            placeholder="Please enter subtitle here"
            value={getState(["subtitle"]) || ""}
            onChange={(value) => {
              updateState(["subtitle"], value);
            }}
          />
        </div>
      </div>

      <div>
        <div className="flex-around">
          <Tabs
            items={slides.map((slide, index) => (
              <span>
                Slide {index + 1}
                {showDelete && (
                  <span
                    className="delete-tab"
                    onClick={(e) => {
                      slides.splice(index, 1);
                      updateState(
                        ["activeIndex"],
                        index !== 0 && index === slides.length
                          ? index - 1
                          : index
                      );
                    }}
                  >
                    &times;
                  </span>
                )}
              </span>
            ))}
            default={activeIndex}
            active={activeIndex}
            onClick={(value) => {
              updateState(["activeIndex"], value);
            }}
          />
          <button
            className="add-tab"
            onClick={(e) => {
              e.preventDefault();
              const slidesCount = slides.length;
              updateState(["slides"], slides.concat(emptySlide));
              updateState(["activeIndex"], slidesCount);
            }}
          >
            + {getMessage("imageSlideShow.addSlide")}
          </button>
        </div>
        <div className="form-sections rich-text-layout">
          <div className="form-section">
            <Input
              label="Author name"
              placeholder="Please enter author's name here"
              value={currentSlide["authorName"]}
              onChange={(value) => {
                newState("authorName", value);
              }}
            />
            <Textarea
              label="Testimonial"
              placeholder="Please enter testimonial here"
              value={currentSlide["testimonial"]}
              maxLength="420"
              onChange={(value) => {
                newState("testimonial", value);
              }}
            />
          </div>
          <div className="form-section">
            <Input
              label="Attribute"
              placeholder="Please enter attribute here"
              value={currentSlide["attribute"]}
              onChange={(value) => {
                newState("attribute", value);
              }}
            />
            <Upload
              label="Author image"
              placeholder="Click here to upload or drag your image"
              value={currentSlide["authorImage"]}
              onChange={(value) => {
                newState("authorImage", value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
const TestimonialLayoutWrp = () => {
  return {
    preview: Testimonial,
    fields: ({ getState, updateState, parent, registerValidation }) => (
      <TestimonialLayout
        getState={getState}
        updateState={updateState}
        parent={parent}
        registerValidation={registerValidation}
      />
    ),
  };
};

export default TestimonialLayoutWrp;
